import React from 'react';
import { useData } from '../../store/DataContext';
import { AlertTriangleIcon, PackageXIcon } from 'lucide-react';
import { isLowStock, isOutOfStock } from './pharmacyUtils';
export function LowStockAlerts() {
  const {
    medicines
  } = useData();
  const out = medicines.filter(isOutOfStock);
  const low = medicines.filter(isLowStock);
  return <div className="space-y-6" data-id="element-4175">
      <div data-id="element-4176">
        <h2 className="text-xl font-bold text-slate-950" data-id="element-4177">Low Stock Alerts</h2>
        <p className="mt-1 text-sm text-slate-500" data-id="element-4178">
          Live alerts based on the medicine reorder level.
        </p>
      </div>
      <AlertGroup title="Out of stock" items={out} icon={PackageXIcon} tone="red" empty="All medicines have stock on hand." data-id="element-4179" />
      <AlertGroup title="Below reorder level" items={low} icon={AlertTriangleIcon} tone="amber" empty="No medicines are below their reorder level." data-id="element-4180" />
    </div>;
}
function AlertGroup({
  title,
  items,
  icon: Icon,
  tone,
  empty
}: {
  title: string;
  items: {
    id: string;
    name: string;
    currentQuantity: number;
    reorderLevel: number;
    sku: string;
  }[];
  icon: typeof AlertTriangleIcon;
  tone: 'red' | 'amber';
  empty: string;
}) {
  return <section className="rounded-xl border border-slate-200 bg-white shadow-sm" data-id="element-4181">
      <div className="flex items-center gap-3 border-b border-slate-100 px-5 py-4" data-id="element-4182">
        <div className={`rounded-lg p-2 ${tone === 'red' ? 'bg-red-50 text-red-700' : 'bg-amber-50 text-amber-700'}`} data-id="element-4183">
          <Icon className="h-4 w-4" data-id="element-4184" />
        </div>
        <div data-id="element-4185">
          <h3 className="font-bold text-slate-900" data-id="element-4186">{title}</h3>
          <p className="text-sm text-slate-500" data-id="element-4187">
            {items.length} medicines need attention
          </p>
        </div>
      </div>
      {items.length ? <div className="divide-y divide-slate-100" data-id="element-4188">
          {items.map(medicine => <div key={medicine.id} className="flex items-center justify-between px-5 py-4" data-id="element-4189">
              <div data-id="element-4190">
                <p className="font-semibold text-slate-900" data-id="element-4191">{medicine.name}</p>
                <p className="mt-0.5 text-sm text-slate-500" data-id="element-4192">
                  {medicine.sku} · reorder at {medicine.reorderLevel}
                </p>
              </div>
              <span className={`rounded-full px-3 py-1 text-sm font-bold ${tone === 'red' ? 'bg-red-100 text-red-700' : 'bg-amber-100 text-amber-700'}`} data-id="element-4193">
                {medicine.currentQuantity} on hand
              </span>
            </div>)}
        </div> : <p className="px-5 py-10 text-center text-sm text-slate-500" data-id="element-4194">{empty}</p>}
    </section>;
}